module.exports = __webpack_public_path__ + "img/public/SiteIcons/editingWishIcon.svg?af08b262";